import React from "react";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { PageContent } from "../../components/PageContent/PageContent";
import { EnvironmentDetail } from "../../components/Environment/EnvironmentDetail";

export const Environment = () => {
  return (
    <>
      <PageHeading>
        <PageHeading.Title>Environment</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <EnvironmentDetail />
      </PageContent>
    </>
  );
};
